export const BackIcon = () => {
  return (
    <svg
      width='20'
      height='12'
      viewBox='0 0 22.8711 14.8438'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <desc>Created with Pixso.</desc>
      <defs />
      <g>
        <path id='路径 9807' d='' fill='#FFFFFF' fill-opacity='0' fill-rule='nonzero' />
        <path
          id='路径 9807'
          d='M8.12 0.7L1.41 7.42L8.12 14.13'
          stroke='#000000'
          stroke-opacity='1.000000'
          stroke-width='2.000000'
          stroke-linejoin='round'
        />
      </g>
      <g>
        <path id='路径 9808' d='' fill='#FFFFFF' fill-opacity='0' fill-rule='nonzero' />
        <path
          id='路径 9808'
          d='M1.41 7.32L22.87 7.32'
          stroke='#000000'
          stroke-opacity='1.000000'
          stroke-width='2.000000'
        />
      </g>
    </svg>
  )
}

export const NewChatIcon = () => {
  return (
    <svg
      viewBox='0 0 1024 1024'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      p-id='13066'
      width='20'
      height='20'
    >
      <path
        d='M512 64c259.2 0 469.333 200.576 469.333 448S771.2 960 512 960a484.48 484.48 0 0 1-232.725-58.88L162.88 951.765a42.667 42.667 0 0 1-58.517-49.002l29.76-125.014C76.629 703.403 42.667 611.477 42.667 512 42.667 264.576 252.8 64 512 64z m0 64c-224.512 0-405.333 172.587-405.333 384 0 79.573 25.557 155.435 72.554 219.285l5.526 7.318 18.709 24.192-26.965 113.237 105.984-46.08 27.477 15.019C370.859 878.229 439.979 896 512 896c224.512 0 405.333-172.587 405.333-384S736.512 128 512 128z m34.133 213.333c4.694 0 8.534 3.84 8.534 8.534v119.466h119.466c4.694 0 8.534 3.84 8.534 8.534V524.8a8.533 8.533 0 0 1-8.534 8.533H554.667V652.8a8.533 8.533 0 0 1-8.534 8.533H499.2a8.533 8.533 0 0 1-8.533-8.533V533.333H371.2a8.533 8.533 0 0 1-8.533-8.533v-46.933c0-4.694 3.84-8.534 8.533-8.534h119.467V349.867c0-4.694 3.84-8.534 8.533-8.534h46.933z'
        fill={window.chatColor ? window.chatColor : '#333333'}
        p-id='13067'
      ></path>
    </svg>
  )
}
